export default "<p>cancellation works!</p>\n";